<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Pemetaan Akun</h1>
          </div>
         <div class="section-body">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Penjualan</h4>
                        </div>
                        <div class="card-body">
                            <div class="col-md-6">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th style="width:50%;">
                                                Pendapatan Penjualan
                                            </th>
                                            <td>
                                                <div class="form-group">
                                                    <select id="pendapatan-penjualan" class="form-control select2">
                                                        <option value="">--- Pilih Akun Pendapatan Penjualan ---</option>
                                                        <option v-for="(option, ind) in akunList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Diskon Penjualan  
                                            </th>
                                            <td>
                                                <div class="form-group">
                                                    <select id="diskon-penjualan" class="form-control select2">
                                                        <option value="">--- Pilih Akun Diskon Penjualan ---</option>
                                                        <option v-for="(option, ind) in akunList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Return Penjualan
                                            </th>
                                            <td>
                                                <div class="form-group">
                                                    <select id="return-penjualan" class="form-control select2">
                                                        <option value="">--- Pilih Akun Retur Penjualan ---</option>
                                                        <option v-for="(option, ind) in akunList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                Pajak Penjualan
                                            </th>
                                            <td>
                                                <div class="form-group">
                                                    <select id="hutang-pajak-penjualan" class="form-control select2">
                                                        <option value="">--- Pilih Akun Pajak Penjualan ---</option>
                                                        <option v-for="(option, ind) in akunList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Pembelian</h4>
                        </div>
                        <div class="card-body">
                            <div class="col-md-6">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th style="width:50%;">
                                                Pembelian
                                            </th>
                                            <td>
                                                <div class="form-group">
                                                    <select id="pembelian" class="form-control select2">
                                                        <option value="">--- Pilih Akun Pembelian ---</option>
                                                        <option v-for="(option, ind) in akunList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style="width:50%;">
                                                Pengiriman
                                            </th>
                                            <td>
                                                <div class="form-group">
                                                    <select id="pengiriman-pembelian" class="form-control select2">
                                                        <option value="">--- Pilih Akun Pendapatan Penjualan ---</option>
                                                        <option v-for="(option, ind) in akunList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style="width:50%;">
                                                Pajak Pembelian
                                            </th>
                                            <td>
                                                <div class="form-group">
                                                    <select id="pajak-pembelian" class="form-control select2">
                                                        <option value="">--- Pilih Akun Pajak Pembelian ---</option>
                                                        <option v-for="(option, ind) in akunList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>AR/AP</h4>
                        </div>
                        <div class="card-body">
                            <div class="col-md-6">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th style="width:50%;">
                                                Piutang Usaha
                                            </th>
                                            <td>
                                                <div class="form-group">
                                                    <select id="piutang-usaha" class="form-control select2">
                                                        <option value="">--- Pilih Akun Piutang Usaha ---</option>
                                                        <option v-for="(option, ind) in akunList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style="width:50%;">
                                                Hutang Usaha
                                            </th>
                                            <td>
                                                <div class="form-group">
                                                    <select id="hutang-usaha" class="form-control select2">
                                                        <option value="">--- Pilih Akun Hutang Usaha ---</option>
                                                        <option v-for="(option, ind) in akunList" v-bind:key="ind" :value="ind" >{{ option.kode_akun }} - {{ option.nama_akun }} </option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="saveSettings()" class="btn btn-light"> <i class="fa fa-check"></i> Simpan</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<style>
    .form-group {
        margin-bottom:0px !important;
    }
</style>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import AddKontak from '../kontak/KontakBaruLite.vue'
import VModal from 'vue-js-modal'

Vue.component('v-select', vSelect)

Vue.use(VModal)

var future = new Date();
future.setDate(future.getDate() + 30);

export default {
    data() {
        return {
            akunList : [],
            settings : [],
        }
    },
    mounted() {
        this. init();
        let that = this
        window.$(document).ready(function(){
            setTimeout(function(){ 
                that.settings.forEach(function(item,index){
                    $("#"+item.key_akun).select2();
                })
            }, 100);
        });
    },
    methods: {
        init: function() {
            var que = 0;
            this.$root.is_loading = !this.$root.is_loading;
            var url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

            // get coa/akun pembayaran
			this.$http.post("Datalist/getCoa").then(result => {
			    if(result.data.code == '00') {
                    alert('failed get coa')
                }
                else {
                    this.akunList = result.data.detail
                }
			}, error => {
				console.log('gk ok')
				context.errors = errors;
            });

            //get akun list
            this.$http.post("Finance/getPemetaanAkun").then(result => {
                if(result.data.code == '00'){
                    console.log('akun list empty')
                }else {
                    this.settings = result.data.detail
                    que = 1
                    if(que == 1){
                        this.setupPage()
                    }
                }
            })

            this.$root.is_loading = false;
        },
        setupPage: function()
        {
            let that = this
            this.settings.forEach(function(item,index){
                if(item.id_coa != 0)
                {
                    var val = that.getIndexOfK(that.akunList,item.id_coa,'id_coa')
                    $("#"+item.key_akun).val(val).trigger('change');
                }
            })
        },
        saveSettings: function()
        {
            let that = this
            this.settings.forEach(function(item,index){
                console.log(item.key_akun);
                var a = $("#"+item.key_akun).select2('val');
                if(a != '')
                {
                    that.settings[index].id_coa = that.akunList[a].id_coa
                }
                else
                {
                    that.settings[index].id_coa = ''
                }
            })

            var formsub = new FormData();
            var objThis = this;

            $.map(objThis.settings, function(value,index){
                formsub.append('settings['+index+'][key_akun]', value.key_akun);
                formsub.append('settings['+index+'][id_coa]', value.id_coa);
            });


            this.$http.post("Finance/updatePemetaanAkun", formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Pemetaan Akun berhasil diinput !',
                        type : 'success'
                    }
                    
                    this.$router.replace({ path : '/settings/pemetaan-akun' })
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Transaksi gagal diinput !',
                        type : 'error'
                    }                    
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        getIndexOfK: function(arr, k, needle) {
            for (var i = 0; i < arr.length; i++) {
                var index = arr[i][needle].indexOf(k);
                if (index > -1) {
                    return i;
                }
            }
        }
    },
    
}
</script>


// WEBPACK FOOTER //
// src/components/settings/PemetaanAkun.vue